import { KIND, SIZE } from 'baseui/button';
import { theme } from 'style/ORSNNTheme';
import { Button } from 'ui-kit';

const buttonFieldClassName =
  '-mt-2.5 -mb-2.5 -ml-3 -mr-3 !px-0 !py-0 border-0 bg-transparent text-brand-400 hover:text-brand-400 hover:underline underline-offset-2 cursor-pointer focus:outline-none';

export const ButtonField = (props: {
  label: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}): JSX.Element => (
  <Button
    kind={KIND.minimal}
    size={SIZE.compact}
    onClick={props.onClick}
    className={buttonFieldClassName}
  >
    {props.label}
  </Button>
);
